var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EntityContext } from './EntityContext';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { ContextSignals } from './actor/ContextSignals';
import { ContextSwitches } from './actor/ContextSwitches';
export class ActorContext extends EntityContext {
    actor_raw;
    constructor(actor) {
        super(actor);
        this.actor_raw = actor;
    }
    get actor() {
        return this.actor_raw;
    }
    get contextSignals() {
        return new ContextSignals(this);
    }
    get contextSwitches() {
        return new ContextSwitches(this);
    }
}
__decorate([
    memoize
], ActorContext.prototype, "contextSignals", null);
__decorate([
    memoize
], ActorContext.prototype, "contextSwitches", null);
